import { IBodyProductSearch, ICatalogState } from 'interfaces/catalog.interface';
import { initialProductsQuantity } from 'utils/constants';

const bodyProductSearch: IBodyProductSearch = {
  options: {
    brand_id: [''],
    favorite: null,
    with_images: null,
    profile: false,
    search: [],
    language_id: '',
    order: ['date+'],
    group: [],
    limit: initialProductsQuantity,
    index: 0,
  },
  filter: {
    reference: [],
    color: [],
    season: [],
    segmentation: [],
    division: [],
    family: [],
    gender: [],
    pvi: [],
    pvpr: [],
    tags: [],
    tiers: [],
  },
};

const bodyProductSearchTemp: IBodyProductSearch = {
  options: {
    brand_id: [''],
    favorite: null,
    with_images: null,
    profile: false,
    search: [],
    language_id: '',
    order: ['date+'],
    group: [],
    limit: initialProductsQuantity,
    index: 0,
  },
  filter: {
    reference: [],
    color: [],
    season: [],
    segmentation: [],
    division: [],
    family: [],
    gender: [],
    pvi: [],
    pvpr: [],
    tags: [],
    tiers: [],
  },
};

const initialCatalogState: ICatalogState = {
  // Catalog
  catalogItems: null,
  bodyProductSearch: bodyProductSearch,
  bodyProductSearchTemp: bodyProductSearchTemp,
  isLoading: true,
  isLoadingMoreProducts: false,
  thereAreMoreProducts: true,
  isEmptyProducts: false,
  getCatalog: () => Promise.resolve(false),
  addMoreProductsToCatalog: () => {},
  addLike: () => Promise.resolve(false),
  isLoadingAddLike: {
    productId: '',
    isLoading: false,
  },
  removeLike: () => Promise.resolve(false),
  isLoadingRemoveLike: {
    productId: '',
    isLoading: false,
  },
  resetCatalog: () => {},
  // Filters
  applyFilters: () => Promise.resolve(false),
  addBodyFilters: () => {},
  removeBodyFilters: () => {},
  resetBodyFilters: () => {},
  setPriceSliders: () => {},
  setFavorites: () => {},
  resetPriceSlider: () => {},
  // Product
  productItem: null,
  isLoadingProduct: true,
  getProduct: () => Promise.resolve(false),
  updateProduct: () => Promise.resolve(false),
  productAttributes: null,
  // Related Products
  relatedProducts: null,
  isLoadingRelatedProducts: false,
  getRelatedProducts: () => Promise.resolve(false),
  // Search engine
  querySearch: '',
  querysearchArray: [],
  setQuerySearch: () => {},
  addToBodySearch: () => {},
  removeFromBodySearch: () => {},
  addToQuerySearchArray: () => {},
  removeFromQuerySearchArray: () => {},
  removeAllFromBodySearch: () => {},
  removeFromBodySearchFilter: () => {},
  // Sort By
  setSortBy: () => {},
  setSortByHaveImages: () => {},
  formatView: '5',
  setFormatView: () => {},
};

export default initialCatalogState;
